// extracted by mini-css-extract-plugin
module.exports = {"warning_box":"WarningBox_warning_box__3mz2T","text_only":"WarningBox_text_only__9ICVE"};